import assert from '@theme/assert';
if (!customElements.get('search-load-more')) {
  class SearchLoadMore extends HTMLElement {
    constructor() {
      super();

      this.paginationLink = this.getAttribute('data-next-page');
      this.loadingIndicator = this.querySelector('.loading-overlay__spinner');
      this.loadMoreButton = this.querySelector('button');
      this.endIndicator = this.querySelector('.end-of-results');
      this.productsContainer = document.querySelector('#product-grid');

      assert(
        !!this.productsContainer,
        'Search load more: Collection page grid container not found'
      );

      if (!this.paginationLink) {
        this.hideComponent();

        return;
      }

      const enableAutoPaginate = this.getAttribute('data-auto-paginate') === 'true';
      if (enableAutoPaginate) {
        this.enableAutoPagination();
        this.loadMoreButton?.classList.add('hidden');
      } else {
        this.loadMoreButton?.addEventListener('click', () => {
          this.fetchNextPage();
        });
      }
      this.updateResultsCount();
    }

    hideComponent() {
      this.style.display = 'none';
    }

    async fetchNextPage() {
      if (!this.productsContainer || !this.paginationLink) return;

      this.showLoading();
      const response = await fetch(this.paginationLink);

      if (!response.ok) {
        this.hideLoading();

        return;
      }

      const html = await response.text();
      this.processNextPage(html);
      this.hideLoading();
    }

    processNextPage(html) {
      const newParsedPage = new DOMParser().parseFromString(html, 'text/html');
      const plpContainer = newParsedPage.querySelector('#ProductGridContainer');
      assert(
        !!plpContainer,
        'Search load more: Fetching next page products failed, could not find element by the id ProductGridContainer'
      );
      if (!plpContainer) return;
      const newProductGridContainer = plpContainer.querySelector('#product-grid');
      assert(
        !!newProductGridContainer,
        'Search load more: Fetching next page products failed, could not find element by the id product-grid'
      );
      if (!newProductGridContainer) return;
      const nextPageProducts = Array.from(newProductGridContainer.children);

      this.addProductsToPage(nextPageProducts);
      this.updateResultsCount();

      const newLazyLoadElement = plpContainer.querySelector('search-load-more');
      newLazyLoadElement ? this.replaceWith(newLazyLoadElement) : this.showEndOfResults();
    }

    addProductsToPage(newProducts) {
      newProducts.forEach((product) => {
        this.productsContainer?.appendChild(product);
      });
    }

    updateResultsCount() {
      const nextPageToLoad = document.querySelector('search-load-more')
        ? document.querySelector('search-load-more').getAttribute('data-next-page')
        : '';

      if (
        window.huntsman?.collectionNextPageUrl &&
        window.huntsman?.collectionNextPageUrl !== nextPageToLoad
      ) {
        window.huntsman.collectionNextPageUrl = nextPageToLoad;
      }
    }

    enableAutoPagination() {
      assert(
        !!window.IntersectionObserver,
        'Search load more: window.IntersectionObserver was not available'
      );

      // initial IntersectionObserver used to lazyload next page
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.fetchNextPage();
              observer.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: '0px 0px 0px 0px',
        }
      );
      observer.observe(this);
    }

    showLoading() {
      // Show loading indicator
      this.loadingIndicator?.classList.remove('hidden');
      if (this.loadMoreButton) {
        this.loadMoreButton.style.display = 'none';
      }
    }

    hideLoading() {
      // Hide loading indicator
      this.loadingIndicator?.classList.add('hidden');
      if (this.loadMoreButton) {
        this.loadMoreButton.style.display = 'block';
      }
    }

    showEndOfResults() {
      this.loadingIndicator?.classList.add('hidden');
      if (this.loadMoreButton) {
        this.loadMoreButton.style.display = 'none';
      }
      this.endIndicator?.classList.remove('hidden');
    }
  }

  customElements.define('search-load-more', SearchLoadMore);
}
